import { render, staticRenderFns } from "./SAASModelTable.vue?vue&type=template&id=2b4d0020"
import script from "./SAASModelTable.vue?vue&type=script&lang=js"
export * from "./SAASModelTable.vue?vue&type=script&lang=js"
import style0 from "./SAASModelTable.vue?vue&type=style&index=0&id=2b4d0020&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports